export default {
  errors: {
    notFound: {
      title: 'Not found',
      description: 'Page {routeName} does not exist.',
    },
  },
  navigation: {
    reflection: 'Reflection',
    journal: 'Journal',
    portfolio: 'Portfolio',
    home: {
      menu: 'Accueil',
      title: 'Noos', // Only used in tests
    },
    notifications: 'Notifications',
  },
  views: {
    reflection: {
      createJournalSection: 'Create a journal section',
      updateJournalSection: 'Edit journal section',
      categories: {
        title: 'Structurer la réflexion',
        steps: {
          1: {
            title: 'Définir les catégories',
            description: 'Pour chaque section, vous pouvez définir plusieurs étiquettes qui vous aidreont à organiser les'
              + ' documents',
          },
          2: {
            title: 'Organiser le rapport',
            description: "À l'aide de votre souris, déplacez les catégories à gauche pour les classer dans un rapport organisé"
              + ' pour vos lecteurs',
            help: 'Vous pouvez utilier la fonction "Glisser et déposer" pour prendre les éléments à gauche et les organiser à'
              + ' droite',
          },
        },
      },
      templateTypes: {
        empty: 'Reflection',
        actionPlan: 'Action plan',
        businessModelCanvas: 'Business model canvas',
        'ulaval-glo-automne2022': 'GLO Template',
      },
      emptyList: 'No reflection',
      inProgress: 'Réflexions en cours',
      completed: 'Réflexions complétées',
      create: 'Create a reflection',
      createdBy: 'Créé par',
      anchorDocuments: "Documents d'ancrage",
      recommendation: {
        analyses: 'Ces recommandations sont appuyées par les documents et analyses suivantes',
      },
      showArchives: 'Montrer les archives',
      tableOfContent: 'Table of content',
      bibliography: 'Bibliography',
      search: {
        input: 'Search',
        keywords: 'Keywords',
        semantic: 'Semantic',
      },
      headers: {
        analyses: 'Analyses',
        details: 'Information sur la réflexion',
        discussion: 'Discussion',
        introduction: 'Introduction',
        generalValue: 'Valeur général',
      },
      tabs: {
        documents: 'Documents',
        reflections: 'Réflexions',
      },
      addToReflection: 'Ajouter à une réflexion',
      synthesisDefaults: {
        OBJECTIVE: 'Les orientations et objectifs visés par ce plan sont appuyées par les références et analyses suivantes:',
        STRATEGY: 'Les enjeux identifiés et stratégies à privilégier sont appuyés par les références et analyses suivantes:',
        TACTICAL: 'Les moyens retenus pour réaliser les stratégies de ce Plan sont appuyés par les références et '
          + 'analyses suivantes:',
        INFO: "Les éléments d'information permettant de comprendre le contexte dans lequel se réalise ce Plan "
          + "d'action sont appuyés par les références et analyses suivantes:",
      },
    },
    redirect: {
      title: 'Redirecting using NOOS extension...',
      description: `If redirection does not work, make sure that the NOOS Chrome extension
        is installed and activated and that you are logged in.`,
      download: 'To install the extension, go to the',
      clickHere: 'Click here',
      redirect: ' to be redirected immediately or wait {timer} seconds',
      browserNotSupported: 'Error: Your browser does not support the NOOS extension.',
      install: 'For a better experience, please use Chrome and install the extension.',
    },
    Login: {
      title: 'Login',
      changePassword: 'Change password',
      email: 'Email',
      password: 'Password',
      newPassword: 'New password',
      confirmation: 'Confirm password',
      sendEmailLinkButton: 'Envoyer un nouveau lien',
      forgotPassword: {
        title: 'Forgot password?',
        message: 'Please enter your email address, we\'ll send you a link to reset your password.',
        sentMessage: 'An email containing a link to reset your password have been sent.',
        sendEmail: 'Send',
        resendEmail: 'Resend',
        emailSent: 'Email sent.',
        invalidEmail: 'Invalid email',
        close: 'Close',
      },
      errors: {
        missingPassword: 'Type a password',
        passwordMismatch: 'Passwords do not match',
        emailMismatch: 'Email must match the one used to receive the invitation link.',
        'auth/user-not-found': 'User not found.',
        'auth/invalid-email': 'Invalid email format.',
        'auth/wrong-password': 'Credentials do not match.',
        'auth/weak-password': 'Password must have at least 6 characters.',
        expired: 'The invitation link has expired. Click on the button to send a new one.',
        notFromEmailLink: 'Please use the invitation link received by email',
        unknown: 'An error occured, please try again',
      },
    },
    portfolio: {
      addToPortfolio: 'Ajouter au portoflio',
      addToPersonalPortfolio: 'Portfolio personnel',
      seeOriginalContent: 'Download original file',
      nonAuthorizedContentDownload: `Ce document est possiblement protégé par
      des droits d'auteur.  Nous vous invitons à faire votre analyse
      directement à partir du site original présenté ci-dessous. Votre analyse
      sera préservée dans son entièreté et liée au lien original dans un
      format d'utilisation équitable sous forme de vignette avec sommaire pour
      vous assurer de sa traçabilité.`,
      personal: {
        title: 'Personal',
        toClassify: 'À Classer',
        allDocuments: 'tous',
        byCategories: 'par Catégories',
      },
      objectives: {
        title: 'Mon portfolio',
        toClassify: 'À classer',
        allDocuments: 'Tous les documents',
      },
      groups: {
        title: 'Mes groupes',
        toClassify: 'À Classer',
        allDocuments: 'tous',
        byCategories: 'par Catégories',
      },
      unsupportedContent: {
        header: 'Pour accéder à ce document, cliquez sur le lien « Voir le contenu original ».',
        note: "Note : Si le document ne s'ouvre pas automatiquement, cliquez ensuite sur le fichier qui sera téléchargé. ",
        help: `Pour ajouter un élément significatif à votre analyse, utiliser la fonction copier,
        puis coller votre sélection dans la zone de commentaires « Réflexion ».
        Au besoin, indiquez pourquoi cet extrait vous apparaît important`,
        help1: '1) à retenir, ',
        help2: '2) à nuancer ou ',
        help3: '3) doit être validé.',
      },
      empty: {
        title: 'Votre portfolio est vide!',
        description: `Ajoutez-y des éléments à partir de votre journal, en utilisant l'extension
        Noos ou les autres fonctionnalités à votre disposition!`,
      },
    },
    home: {
      title: 'Welcome to your NOOS',
      content: 'To start capturing documents and sharing them, install the NOOS extension for the Chrome Web browser.',
      download: 'Download with the Chrome Web Store',
    },
    journal: {
      title: 'Journal',
      messages: {
        beta: 'This journal section is in beta, we\'d love your feedback to make it better!',
        loading: 'Recommendations loading, please come back in a few minutes!',
      },
      sections: {
        addSection: 'Add a section',
        spotlight: 'Newscast',
        groups: 'Groups sections',
        reflections: 'Reflections sections',
        groupsAnalyses: 'Groups analyses',
        relatedToUserAnalyses: 'Related to your analyses',
        relatedToGroupsAnalyses: 'Related to your groups analyses',
        organisation: 'Organisation (actuality)',
        personal: 'Personal sections',
        header: {
          members: {
            tooltip: {
              forGroup: 'Recommendations are visible to all group members.',
              forReflection: 'Recommendations are visible to all memebrs participating to the reflection.',
              forUser: 'Recommendations are only visible to you.',
            },
          },
          settings: {
            tooltip: "Modify this journal section's search parameters.",
          },
          archive: {
            tooltip: 'Archive this journal section.',
          },
          history: {
            tooltip: 'View recommendations history.',
          },
        },
      },
      cards: {
        actions: {
          searchSimilar: {
            tooltip: 'Rechercher des documents similaires',
          },
          rate: {
            tooltip: 'Cote qui représente la pertinence de la recommandation',
            descriptions: {
              0: [
                'Horrible',
                'Nonesense',
                'Baloney',
                'To forget',
              ],
              1: ['Not good', 'Not the best', 'Passable', 'So-so'],
              2: ['Correct', 'Ok', 'Usable'],
              3: ['Good', 'Interesting', 'I like!'],
              4: ['Amazing!', 'Incredible', 'Perfect', 'Genius!'],
            },
          },
        },
      },
      searchSimilar: {
        title: 'Similar to : {documentTitle}',
        more: 'More recommendations',
      },
    },
  },
  components: {
    editor: {
      share: 'Share',
      format: {
        bold: 'Bold',
        italic: 'Italic',
        strikethrough: 'Strikethrough',
        underline: 'Underline',
        highlight: 'Highlight',
        code: 'Code',
        clear: 'Clear styling',
        bulletList: 'Bullet list',
        numberedList: 'Numbered list',
        quote: 'Quote bloc',
      },
      image: 'Image',
      imageMenuActions: {
        upload: 'Upload from computer',
        urlLink: 'With URL',
      },
      imageInsertionDialog: {
        formTitle: 'Image insertion',
        imageUrl: 'Image URL',
        imageTitle: 'Title',
        imageAlt: 'Alternative text',
        invalidImageMessage: 'Error: the selected file is not a valid image',
        uploadErrorMessage: `An error occured while uploading.
          Please try again or contact support if the problem persists.`,
        invalidUrlMessage: 'The specified URL is invalid',
        insertLinkButtonLabel: 'Insert',
        insertUploadAndLinkButtonLabel: 'Upload and insert',
        cancelButtonLabel: 'Cancel',
      },
      table: 'Table',
      tableMenuActions: {
        insert: 'Insert table',
        addRowBefore: 'Add row before',
        addRowAfter: 'Add row after',
        addColumnBefore: 'Add column before',
        addColumnAfter: 'Add column after',
        deleteRow: 'Delete row',
        deleteColumn: 'Delete column',
        deleteTable: 'Remove table',
        mergeCells: 'Join cells',
        splitCell: 'Split cell',
        headerRow: 'Header row',
        headerColumn: 'Header column',
      },
      horizontalRule: 'Horizontal rule',
      newline: 'Newline',
      helpBloc: 'Help bloc',
      actions: {
        undo: 'Undo',
        redo: 'Redo',
        download: {
          pdf: 'Download as PDF',
        },
      },
      styles: {
        paragraph: 'Paragraph',
        heading1: 'Heading 1',
        heading2: 'Heading 2',
        heading3: 'Heading 3',
        heading4: 'Heading 4',
        heading5: 'Heading 5',
        heading6: 'Heading 6',
        preformatted: 'Preformatted',
      },
      journal: 'Add a journal section',
    },
    DataIterator: {
      pagination: {
        currentPageOf: 'de',
      },
    },
    cards: {
      horizontal: {
        publishedDate: 'Published on {datePublished}',
      },
      vertical: {
        delete: 'Delete',
      },
    },
    Objectives: {
      filter: {
        noData: 'Aucun objectif ne satisfait votre recherche',
      },
    },
    Reflection: {
      success: 'Votre réflexion a bien été sauvegardée.',
    },
  },
  journal: {
    recommendationHistory: {
      title: 'Recommendations history',
    },
    sectionCreation: {
      title: 'Recommendations',
      create: 'Create section',
      update: 'Update section',
      tabs: {
        name: 'Search {index}',
        add: 'Add a search',
        split: 'View side-by-side',
      },
    },
    search: {
      title: 'Advanced search',
      results: 'Results',
      criterias: {
        title: 'Add a search criteria',
        score: 'Score weight',
        semantic: {
          name: 'Semantic',
          input: 'Semantic search',
        },
        keywords: {
          name: 'Keywords',
          input: 'Keywords bias',
        },
        timeDecay: {
          name: 'Time decay',
          input: 'Half-life in days',
        },
        url: {
          name: 'URL',
          input: 'URL bias',
          score: 'URL weight',
        },
        portfolio: {
          name: 'Portfolio',
          input: 'Portfolio bias',
        },
      },
      filters: {
        title: 'Add a filter',
        included: 'Included',
        excluded: 'Excluded',
        keywords: {
          name: 'Keywords',
          input: 'Filter by keywords',
        },
        time: {
          name: 'Time window',
          input: 'X last days',
        },
        url: {
          name: 'URL',
          input: 'Filter by URL',
        },
      },
      recommendations: 'Recommendations',
      sectionNamePlaceholder: 'Journal section name',
    },
  },
  search: {
    noResults: {
      title: 'No search results',
      descriptions: {
        awaiting: 'Results will appear here.',
        failed: 'An error occured. Please try again.',
        noneFound: 'Try to tweak your search criterias and filters.',
      },
    },
  },
};
